export enum OrderHistoryPeriods {
    CUSTOM = 'Custom',
    ALL_HISTORY = 'LastYear',
    LAST_MONTH = 'LastMonth',
    LAST_WEEK = 'LastWeek',
    LAST_THREE_DAY = 'LastThreeDays',
    TODAY = 'Today'
}